import axios from 'axios'

// initial state
const state = () => ({
  showCardInput: true // 默認顯示卡號輸入區塊
})

// getters
const getters = {}

const actions = {
  setTpass ({ commit }) {
    // 設置 localStorage
    // localStorage.setItem('easycard-expires', '2025-05-20')
    // commit('SET_TPASS', '2025-05-20')
  },
  GetUUCardExpired ({ commit }, cardNumber) {
    return new Promise((resolve, reject) => {
      // 移除 cardNumber 中的所有空白字符
      const sanitizedCardNumber = cardNumber.replace(/\s+/g, '')
      axios
        .post('/api/EASYCARD/QueryEndDate', { CardNumber: sanitizedCardNumber }) // 建議改為大寫
        .then(response => {
          const expiryDate = response.data && response.data.expiryDate ? response.data.expiryDate : ''
          // 儲存到 localStorage
          const cardData = {
            CardNumber: cardNumber,
            ExpiryDate: expiryDate
          }
          localStorage.setItem('easycard-expires', JSON.stringify(cardData))

          resolve(expiryDate) // 回傳到期日
        })
        .catch(error => {
          if (error.response) {
            if (error.response.status === 500) {
              reject(new Error('卡號無效或效期不符')) // 500 Internal Server Error 時顯示特定錯誤訊息
            } else if (error.response.data) {
              reject(new Error(error.response.data)) // 傳遞 API 返回的錯誤訊息
            } else {
              reject(new Error('卡號無效或效期不符')) // 發生其他錯誤時返回
            }
          } else {
            reject(new Error('卡號無效或效期不符')) // 發生其他錯誤時返回
          }
        })
    })
  },
  checkEasyCardExpires ({ commit }) {
    const cardData = JSON.parse(localStorage.getItem('easycard-expires'))
    if (cardData) {
      const expiryDate = new Date(
        cardData.ExpiryDate.substring(0, 4), // 年
        cardData.ExpiryDate.substring(4, 6) - 1, // 月 (0-11)
        cardData.ExpiryDate.substring(6, 8) // 日
      )
      const currentDate = new Date()
      if (expiryDate >= currentDate) {
        commit('SET_SHOW_CARD_INPUT', false)
      } else {
        localStorage.removeItem('easycard-expires') // 刪除過期的資料
        commit('SET_SHOW_CARD_INPUT', true)
      }
    } else {
      commit('SET_SHOW_CARD_INPUT', true)
    }
  }
}

// mutations
const mutations = {
  SET_TPASS (state, value) {
    state.tpass = value
  },
  SET_SHOW_CARD_INPUT (state, value) {
    state.showCardInput = value
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
